module.exports = __webpack_public_path__ + "static/media/team-member-zac.83f8ef0f.jpg";